import { Sort } from '../config/types/config';
import Job from '../jobs/types/job';

const useSorting = (jobs: Job[], sort: Sort): Job[] =>
  jobs.sort((a, b) => {
    const direction = sort.order === 'desc' ? 1 : -1;
    switch (sort.by) {
      case 'date':
        return (b.sortDate.getTime() - a.sortDate.getTime()) * direction;
      case 'title':
        return b.position.localeCompare(a.position) * direction;
      default:
        return 0;
    }
  });

export default useSorting;
